import { useMemo } from "react";
import { Card } from "./ui/card";
import { detectGlossary } from "../lib/glossary";

/**
 * Panneau de l'éditeur (cours et analyses) : mots du glossaire trouvés dans le texte.
 * Décocher un mot retire son lien automatique (liste « off » enregistrée avec le contenu).
 */
export default function GlossaryPanel({ html, terms, off, onChange, testid = "course-glossary-panel" }) {
  const found = useMemo(() => detectGlossary(html, terms), [html, terms]);
  const byId = Object.fromEntries(terms.map((t) => [t.id, t]));
  const offSet = new Set(off);
  return (
    <Card className="p-5 bg-card border-white/5 space-y-3" data-testid={testid}>
      <div className="text-xs uppercase tracking-[0.2em] text-emerald-400">Mots du glossaire</div>
      <p className="text-xs text-zinc-500 leading-relaxed">
        Détectés automatiquement à la première apparition de chaque mot. Décochez un mot pour retirer son lien.
      </p>
      {found.auto.length === 0 ? (
        <p className="text-xs text-zinc-600">Aucun mot du glossaire détecté dans le texte.</p>
      ) : (
        <div className="space-y-1">
          {found.auto.map((tid) => (
            <label key={tid} className="flex items-center gap-2.5 py-0.5 text-sm cursor-pointer">
              <input
                type="checkbox"
                checked={!offSet.has(tid)}
                onChange={(e) => onChange(e.target.checked ? off.filter((x) => x !== tid) : [...off, tid])}
                className="accent-emerald-500 w-4 h-4"
              />
              <span className={offSet.has(tid) ? "text-zinc-500 line-through" : "text-zinc-200"}>{byId[tid]?.title}</span>
            </label>
          ))}
        </div>
      )}
      <div className="pt-3 border-t border-white/5">
        <div className="text-[11px] text-zinc-500 mb-1">Ajoutés à la main</div>
        {found.manual.length ? (
          found.manual.map((tid) => <div key={tid} className="text-sm text-zinc-300 py-0.5">{byId[tid]?.title}</div>)
        ) : (
          <p className="text-[11px] text-zinc-600 leading-relaxed">Sélectionnez un mot dans le texte, puis cliquez sur « Glossaire » dans la barre d'outils. Pour retirer ce lien, recliquez sur « Glossaire ».</p>
        )}
      </div>
    </Card>
  );
}
